import React from 'react'
import { FieldErrors } from 'react-hook-form'
import { Button } from '../Button/Button'
import './FormSaveBar.scss'

interface FormSaveBarProps {
  isVisible: boolean
  isSubmitting: boolean
  isValid: boolean
  isDirty: boolean
  errors: FieldErrors
  onDiscard: () => void
  showNavigationWarning?: boolean
  onConfirmLeave?: () => void
  onCancelLeave?: () => void
}

export const FormSaveBar: React.FC<FormSaveBarProps> = ({ isVisible, showNavigationWarning, ...props }) => {
  if (!isVisible && !showNavigationWarning) return null

  return <FormSaveBarContent isVisible={isVisible} showNavigationWarning={showNavigationWarning} {...props} />
}

const FormSaveBarContent: React.FC<FormSaveBarProps> = ({ ...props }) => {
  const innerPillClass =
    'd-flex justify-content-between align-items-center zocks-bg-color-gray-900 zocks-border-0.5 zocks-p-1.25 shadow-lg mx-auto col-11 col-lg-10 inner-pill-style'

  if (props.showNavigationWarning) {
    return (
      <div className='outer-container-style'>
        <div className={innerPillClass}>
          <div className='d-flex align-items-center zocks-gap-0.75'>
            <i className='bi bi-exclamation-square zocks-text-danger fs-5' />
            <span className='zocks-text-white fw-medium'>Are you sure you want to leave?</span>
          </div>
          <div className='d-flex zocks-gap-0.75'>
            <Button type='button' variant='primaryGhost' className='border-0' onClick={props.onCancelLeave}>
              Back
            </Button>
            <Button type='button' variant='danger' className='border-0' onClick={props.onConfirmLeave}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    )
  }

  if (props.isDirty && !props.isValid) {
    return (
      <div className='outer-container-style'>
        <div className={innerPillClass}>
          <div className='d-flex align-items-center zocks-gap-0.75'>
            <i className='bi bi-exclamation-square zocks-text-danger fs-5' />
            <span className='zocks-text-white fw-medium'>Complete all required fields...</span>
          </div>
          <div className='d-flex zocks-gap-0.75'>
            <Button type='button' variant='primaryGhost' className='border-0' onClick={props.onDiscard}>
              Cancel
            </Button>
            <Button type='button' variant='primary' disabled className='border-0' loading={props.isSubmitting}>
              Save
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='outer-container-style'>
      <div className={innerPillClass}>
        <div className='d-flex align-items-center'>
          <span className='zocks-text-gray-500'>You updated your settings</span>
        </div>
        <div className='d-flex zocks-gap-0.75'>
          <Button type='button' variant='primaryGhost' className='border-0' onClick={props.onDiscard} disabled={props.isSubmitting}>
            Discard
          </Button>
          <Button variant='primary' type='submit' form='integration-settings-form' className='border-0' disabled={props.isSubmitting}>
            {props.isSubmitting ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </div>
    </div>
  )
}
